import axios from 'axios';

import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Typography,
} from '@mui/material';

import React, { useState } from 'react';

import { toast } from 'react-toastify';

import { useAuth } from '@src/contexts/authContext';

const url = `${process.env.REACT_APP_API_URL}/admin/certificate-items`;

export default function EditCertItems({
  openModals,
  setOpenModals,
  fetchData,
}) {
  const { auth } = useAuth();
  const [data, setData] = useState({ item: '', role: [] });

  React.useEffect(() => {
    const fetchDataAsync = async () => {
      try {
        if (openModals) {
          const response = await axios.get(`${url}/${openModals}`, {
            headers: {
              Authorization: `Bearer ${auth.idToken}`,
            },
          });

          setData({
            ...response.data,
          });
        }
      } catch (error) {
        console.log(error);
      }
    };

    fetchDataAsync();
  }, [auth.idToken, openModals]);

  const handlePost = () => {
    const formData = {
      item: data?.item,
      role: 'doctor',
    };

    axios
      .put(`${url}/${openModals}`, formData, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${auth.idToken}`,
        },
      })
      .then((response) => {
        console.log('Item updated successfully:', response);
        setData({ ...data });
        fetchData();
        toast.success('Item updated successfully', {
          position: 'top-center',
          autoClose: 2000,
        });
      })
      .catch((error) => {
        console.log(error.message);
        toast.error(`${error.response.data.message}`, {
          position: 'top-center',
          autoClose: 2000,
        });
      });
  };

  return (
    <Dialog
      maxWidth='lg'
      fullwidth
      open={openModals}
      onClose={() => setOpenModals(false)}
    >
      <DialogTitle>Edit item</DialogTitle>
      <br />

      <DialogContent>
        <Box flex={1} mr={1}>
          <Typography fontFamily='Poppins'>Item*</Typography>
          <TextField
            fullWidth
            size='medium'
            variant='outlined'
            placeholder='Enter item'
            sx={{
              '& .MuiOutlinedInput-root': {
                borderRadius: '6px',
              },
              mt: '5px',
              width: '600px',
            }}
            value={data?.item}
            onChange={(e) =>
              setData({
                ...data,
                item: e.target.value,
              })
            }
          />
          <br />
          <br />
        </Box>
      </DialogContent>

      <DialogActions>
        <Button
          sx={{ textTransform: 'none' }}
          onClick={() => {
            setOpenModals(false);
          }}
          color='secondary'
        >
          Done
        </Button>
        <Button
          sx={{ textTransform: 'none' }}
          color='primary'
          onClick={() => {
            handlePost();
            setOpenModals(false);
          }}
        >
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
}
